import { resolve } from './plugins';
import AxiosPlugin from './plugins/axios';
import { instance } from './store';
import { transformCRMOptions, transformAxiosOption } from './initial-state';
import { logger } from './logger';

import type { PluginFunction } from '@kastjs/runtime-core';
import type { CRMOptions } from './types';

export const PluginCRM: PluginFunction<CRMOptions> = async (context, options) => {
  if (!options) return context;

  /** 如果启用 axios 的逻辑的话，要放在第一次执行：原因是插件内部也会发送请求 */
  if (options.axios !== false) {
    transformAxiosOption(context, options);
    if (options.reflush !== true) {
      await context.app.setup(AxiosPlugin, options?.axios || {});
    }
  }

  /** 针对门户切换业务线逻辑，重置内置保存的值 */
  if (options.reflush === true) {
    instance.clear();
  }

  /** 处理用户输入参数，转为各插件需要的入参 */
  const resultOptions = await transformCRMOptions(options);

  /** 主应用下发数据给子应用使用 */
  resultOptions.isMain && instance.setAll(resultOptions);

  /** 执行插件 */
  await resolve(context, resultOptions);

  /** 打印日志 */
  resultOptions.logger ? logger.print(resultOptions, context) : logger.clear();
};

export const globalStore = {
  getAll: instance.getAll.bind(instance) as typeof instance.getAll,
  set: instance.setUser.bind(instance) as typeof instance.setUser,
};
